import React from "react";
import {useCurrentFrame, useVideoConfig, spring, interpolate, random} from "remotion";
import {CLAMP} from "../../presets/idv";

const DEFAULT_COLORS = ["#00DF82", "#FECB18", "#1E3A61", "#ffffff", "#86868b"];

// Confetti particle explosion — deterministic with random('seed')
export const Confetti: React.FC<{
  triggerFrame: number;
  particleCount?: number;
  colors?: string[];
}> = ({triggerFrame, particleCount = 30, colors = DEFAULT_COLORS}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();
  const localFrame = frame - triggerFrame;
  if (localFrame < 0) return null;

  return (
    <>
      {Array.from({length: particleCount}, (_, i) => {
        const angle =
          (i / particleCount) * Math.PI * 2 + random(`angle-${i}`) * 0.5;
        const speed = 4 + random(`speed-${i}`) * 8;
        const size = 4 + random(`size-${i}`) * 6;
        const color =
          colors[Math.floor(random(`color-${i}`) * colors.length)];

        const explode = spring({
          frame: localFrame,
          fps,
          config: {stiffness: 350, damping: 20, mass: 0.3},
        });

        const x = Math.cos(angle) * speed * 30 * explode;
        const y = Math.sin(angle) * speed * 20 * explode;
        const gravity =
          localFrame > 5 ? Math.pow(localFrame - 5, 2) * 0.005 : 0;
        const fadeOut = interpolate(localFrame, [20, 50], [1, 0], CLAMP);
        const rotation = localFrame * (3 + i);

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              width: size,
              height: size * 0.6,
              borderRadius: size > 7 ? 2 : 999,
              background: color,
              opacity: fadeOut,
              transform: `translate(${x}px, ${y + gravity}px) rotate(${rotation}deg)`,
            }}
          />
        );
      })}
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
